/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { AwsEbsSnapshotConvertResult } from '../models/AwsEbsSnapshotConvertResult';
import { AwsEbsVolumeRestoreResult } from '../models/AwsEbsVolumeRestoreResult';
import { AwsEc2AmiConvertResult } from '../models/AwsEc2AmiConvertResult';
import { AwsEc2InstanceRestoreResult } from '../models/AwsEc2InstanceRestoreResult';
import { AzureDiskRestoreResult } from '../models/AzureDiskRestoreResult';
import { AzureVmInstanceRestoreResult } from '../models/AzureVmInstanceRestoreResult';
import { EksNamespaceRestoreResult } from '../models/EksNamespaceRestoreResult';
import { GcpVmInstanceRestoreResult } from '../models/GcpVmInstanceRestoreResult';
import { RecordRestoreResult } from '../models/RecordRestoreResult';

export class RestoreResult {
  'awsEc2Instance'?: AwsEc2InstanceRestoreResult | null;
  'awsEc2Ami'?: AwsEc2AmiConvertResult | null;
  'awsEbsVolume'?: AwsEbsVolumeRestoreResult | null;
  'awsEbsSnapshot'?: AwsEbsSnapshotConvertResult | null;
  'azureDisk'?: AzureDiskRestoreResult | null;
  'azureVmInstance'?: AzureVmInstanceRestoreResult | null;
  'gcpVmInstance'?: GcpVmInstanceRestoreResult | null;
  'recordRestore'?: RecordRestoreResult | null;
  'eksNamespaceRestore'?: EksNamespaceRestoreResult | null;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "awsEc2Instance",
      "baseName": "awsEc2Instance",
      "type": "AwsEc2InstanceRestoreResult",
      "format": ""
    },
    {
      "name": "awsEc2Ami",
      "baseName": "awsEc2Ami",
      "type": "AwsEc2AmiConvertResult",
      "format": ""
    },
    {
      "name": "awsEbsVolume",
      "baseName": "awsEbsVolume",
      "type": "AwsEbsVolumeRestoreResult",
      "format": ""
    },
    {
      "name": "awsEbsSnapshot",
      "baseName": "awsEbsSnapshot",
      "type": "AwsEbsSnapshotConvertResult",
      "format": ""
    },
    {
      "name": "azureDisk",
      "baseName": "azureDisk",
      "type": "AzureDiskRestoreResult",
      "format": ""
    },
    {
      "name": "azureVmInstance",
      "baseName": "azureVmInstance",
      "type": "AzureVmInstanceRestoreResult",
      "format": ""
    },
    {
      "name": "gcpVmInstance",
      "baseName": "gcpVmInstance",
      "type": "GcpVmInstanceRestoreResult",
      "format": ""
    },
    {
      "name": "recordRestore",
      "baseName": "recordRestore",
      "type": "RecordRestoreResult",
      "format": ""
    },
    {
      "name": "eksNamespaceRestore",
      "baseName": "eksNamespaceRestore",
      "type": "EksNamespaceRestoreResult",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return RestoreResult.attributeTypeMap;
  }

  public constructor() {
  }
}

